export const strict = false
import mutationsI from './mutations'
import actionsI from './actions'

const config = {
	graphqlUrl: process.env.GRAPHQL_HOST || "https://dev.savingforcollege.com/graphql",
	s3ResourceHost: process.env.S3_RESOURCE_HOST || "https://web-resources.savingforcollege.com",
	sfcHost: process.env.SFC_PHP_URL || "https://dev.savingforcollege.com",

	// NOT IDEAL BUT FOR THE EXPERIMENT COOKIES TO SET PROPERLY ON LOCALHOST, WE NEED TO DEFAULT domain TO 'local.savingforcollege.com'
	// ALWAYS RETURN TO 'dev.savingforcollege.com' before deploying
	domain: process.env.DOMAIN || "dev.savingforcollege.com", 
	userManagementHost: process.env.USER_MANAGEMENT_HOST || "https://devusermanagment.savingforcollege.com",
	searchApiHost: process.env.SEARCH_API_HOST || "https://ede72179a0cf4eeaa090cd8b5cb3fa86.us-west-2.aws.found.io",
	sitesUrl: process.env.SFC_SITES_URL || "https://sitesdev.savingforcollege.com",

	s3FooterJsonUrl: process.env.S3_FOOTER_URL || "https://s3-us-west-2.amazonaws.com/webresources.savingforcollege.com/layout_tests/footer.json",
	s3MenuJsonUrl: process.env.S3_MENU_URL || "https://s3-us-west-2.amazonaws.com/webresources.savingforcollege.com/layout_tests/menu.json",

	googleTagManagerKey: process.env.GTM_KEY || "GTM-W48F8PZ",
	gtagKey: process.env.GTAG_KEY || "G-LWF9KJEEKY",
	stripeKey: process.env.STRIPE_KEY || "pk_test_TFT3phAGYa4Ro22TyTPbkcXn",

	heapKey: process.env.HEAP_KEY || "1451216604",

	prudentialProevaluatorUrl: process.env.PRUDENTIAL_PROEVALUATOR_URL || "https://devprudentialpro529evaluator.savingforcollege.com",
	prudentialReportUrl: process.env.PRUDENTIAL_REPORT_URL || "https://dev.savingforcollege.com",

	skipHttpsValidation: process.env.SKIP_HTTPS || true,

	familyGuideImage: "https://web-resources.savingforcollege.com/images/family_guide_2024_2025.png",
	familyGuideUrl: "https://web-resources.savingforcollege.com/guides/family_guide_2024_2025.pdf",

	taxDataJsonUrl: process.env.TAX_DATA_JSON_URL || "https://web-resources.savingforcollege.com/data_test/tax_data.json",

	wordpressApiUrl: process.env.WORDPRESS_API_URL || "https://dev-wordpress.savingforcollege.com/wp-json/wp/v2",

	articlesPageVersion: '1',
	bestPlansPageVersion: '2',
	comparisonPageVersion: '1',
	introTo529sVersion: '1',
	k12CalculatorPageVersion: '1',
	planDetailsPageVersion: '1',
	smartConsultLandingPageVersion: '1',
	statePageVersion: '2',
	tRowePlanLandingPageVersion: '1',
	worldsSimplestPageVersion: '2'
}

export const state = () => ({
	config: config,
	userIsLoggedIn: false,
	userEmail: "",
	sfcId: "",
	sfcSubscriptions: "",
	sfcSubscriptionOrders: "",
	plansWithInstitutions: null,
	taxInfo: null,
	menu: null,
	footer: null,
	hideEnrollNowBanner: true,
	hideUpromiseBanner: true,
	dismissUpromiseBanner: false,
	bestPlansExitModalContent:{},
	takeoverInfo: null,
	takeoverIsOpened: false,
	stateOfResidence: null,
	hasA529Plan: null,
	childAge: null,
	toCollegeSavingsModalComingFrom: null,
	savingsUser: null,
	closePathModal: false,
	savingsLearnSection: null,
	locale: 'en',
	plansToCompare: [],
	stateFromIp: null,
	currentIp: null,
	csjourney: "",
	csgifting: "",

	collegeSavingsUserOnboarding: {
		questionsPerCategory: [
			{
				category: "Start",
				questions: ['state-of-residence-question','user-type-question', 'tax-filing-status-question', 'household-income-question']
			},
			{
				category: "Children",
				questions: [
					// 'children-savings-question',
					'children-savings-total-question']
			},
			{
				category: "Your Needs",
				questions: ['more-help-question', 'email-capture-question']
			},
			{
				category: "Recommendations",
				questions: ['loading-screen']
			},
		],
		userTypeError: true,
		taxFilingStatusError: true,
		householdInconmeError: true,
		emailError: false,
		childrenError: false,
		monthlyContributionError: true,
		showAllErrors: false,
		showErrorBanner: false,
		youngerAge: null,
		olderAge: null,
		childrenCount: null,
	},
	states: [
	{
		id: 1,
		name: "Alabama",
		string_id: "AL"
	},
	{
		id: 2,
		name: "Alaska",
		string_id: "AK"
	},
	{
		id: 3,
		name: "Arizona",
		string_id: "AZ"
	},
	{
		id: 4,
		name: "Arkansas",
		string_id: "AR"
	},
	{
		id: 5,
		name: "California",
		string_id: "CA"
	},
	{
		id: 6,
		name: "Colorado",
		string_id: "CO"
	},
	{
		id: 7,
		name: "Connecticut",
		string_id: "CT"
	},
	{
		id: 8,
		name: "Delaware",
		string_id: "DE"
	},
	{
		id: 9,
		name: "District of Columbia",
		string_id: "DC"
	},
	{
		id: 10,
		name: "Florida",
		string_id: "FL"
	},
	{
		id: 11,
		name: "Georgia",
		string_id: "GA"
	},
	{
		id: 12,
		name: "Hawaii",
		string_id: "HI"
	},
	{
		id: 13,
		name: "Idaho",
		string_id: "ID"
	},
	{
		id: 14,
		name: "Illinois",
		string_id: "IL"
	},
	{
		id: 15,
		name: "Indiana",
		string_id: "IN"
	},
	{
		id: 16,
		name: "Iowa",
		string_id: "IA"
	},
	{
		id: 17,
		name: "Kansas",
		string_id: "KS"
	},
	{
		id: 18,
		name: "Kentucky",
		string_id: "KY"
	},
	{
		id: 19,
		name: "Louisiana",
		string_id: "LA"
	},
	{
		id: 20,
		name: "Maine",
		string_id: "ME"
	},
	{
		id: 21,
		name: "Maryland",
		string_id: "MD"
	},
	{
		id: 22,
		name: "Massachusetts",
		string_id: "MA"
	},
	{
		id: 23,
		name: "Michigan",
		string_id: "MI"
	},
	{
		id: 24,
		name: "Minnesota",
		string_id: "MN"
	},
	{
		id: 25,
		name: "Mississippi",
		string_id: "MS"
	},
	{
		id: 26,
		name: "Missouri",
		string_id: "MO"
	},
	{
		id: 27,
		name: "Montana",
		string_id: "MT"
	},
	{
		id: 28,
		name: "Nebraska",
		string_id: "NE"
	},
	{
		id: 29,
		name: "Nevada",
		string_id: "NV"
	},
	{
		id: 30,
		name: "New Hampshire",
		string_id: "NH"
	},
	{
		id: 31,
		name: "New Jersey",
		string_id: "NJ"
	},
	{
		id: 32,
		name: "New Mexico",
		string_id: "NM"
	},
	{
		id: 33,
		name: "New York",
		string_id: "NY"
	},
	{
		id: 34,
		name: "North Carolina",
		string_id: "NC"
	},
	{
		id: 35,
		name: "North Dakota",
		string_id: "ND"
	},
	{
		id: 36,
		name: "Ohio",
		string_id: "OH"
	},
	{
		id: 37,
		name: "Oklahoma",
		string_id: "OK"
	},
	{
		id: 38,
		name: "Oregon",
		string_id: "OR"
	},
	{
		id: 39,
		name: "Pennsylvania",
		string_id: "PA"
	},
	{
		id: 40,
		name: "Rhode Island",
		string_id: "RI"
	},
	{
		id: 41,
		name: "South Carolina",
		string_id: "SC"
	},
	{
		id: 42,
		name: "South Dakota",
		string_id: "SD"
	},
	{
		id: 43,
		name: "Tennessee",
		string_id: "TN"
	},
	{
		id: 44,
		name: "Texas",
		string_id: "TX"
	},
	{
		id: 45,
		name: "Utah",
		string_id: "UT"
	},
	{
		id: 46,
		name: "Vermont",
		string_id: "VT"
	},
	{
		id: 47,
		name: "Virginia",
		string_id: "VA"
	},
	{
		id: 48,
		name: "Washington",
		string_id: "WA"
	},
	{
		id: 49,
		name: "West Virginia",
		string_id: "WV"
	},
	{
		id: 50,
		name: "Wisconsin",
		string_id: "WI"
	},
	{
		id: 51,
		name: "Wyoming",
		string_id: "WY"
	}],
	lastAdsUpdate: 0,
	savingsCenterLearnCollegeCostHouseholdIncome: 50000,
	savingsCenterLearnCollegeCostChildAgeUpdated: false,
	savingsCenterLearnCollegeUsedInitialChildAge: false,
	// savingsCenterLearnCollegeCostChildAge: 2,
	savingsCenterLearnCollegeCostCollegeId: 2,
	savingsCenterInterstitial: { opened: false},

	financialAidCalculatorLicensedCompanies: ["fs", "cm", "ts", "ia"]
})

export const mutations = mutationsI

export const actions = actionsI
